import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function DefaultedLoanAccounting({ children }) {
  return (
    <div>
      <CustomPageHeader icon='magic' text='Accounting for defaulted loans' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/DefaultedLoanAccounting/index.js